import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const itineraryEntity: Entity = {
  model: model,
  repository: repository,
}

export default itineraryEntity
